import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yiminghan/callcow/apps/web-app/src/app/(landing)/client-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/Users/yiminghan/callcow/apps/web-app/src/trpc/react.tsx");
